import { render } from "./AddIcon.vue?vue&type=template&id=74b97e23&scoped=true"
import script from "./AddIcon.vue?vue&type=script&lang=js"
export * from "./AddIcon.vue?vue&type=script&lang=js"

import "./AddIcon.vue?vue&type=style&index=0&id=74b97e23&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b97e23"]])

export default __exports__